import { Injectable } from '@angular/core'
import { ErrorResponse } from 'angular2-jsonapi'
import { Observable } from 'rxjs/Observable'

import 'rxjs/add/observable/empty'
import 'rxjs/add/observable/forkJoin'
import 'rxjs/add/operator/concatMap'

import { Exportacao } from '../../../pkw-data/collect/exportacao.model'
import { PkwDatastore } from '../../../pkw-data/pkw-datastore'
import { ConfiguracaoExportacao } from './configuracao-exportacao'
import { ErroExportacao } from './error-exportacao'
import { ExportacaoFinalizada } from './exportacao-finalizada'

@Injectable()
export class ExportacaoService {
    constructor(private pkwDatastore: PkwDatastore) {}

    nova() {
        return this.pkwDatastore.createRecord(Exportacao)
    }

    gerar(config: ConfiguracaoExportacao, formato: string): Observable<ExportacaoFinalizada> {
        const exportacoes = config.gerarExportacoes(this.pkwDatastore)
        const retornos$ = exportacoes.map(exportacao => 
            exportacao.save().catch(error => {
                if (error instanceof ErrorResponse) {
                    const erroExportacao = new ErroExportacao(
                        exportacao,
                        // error.errors.map(err => err.title)
                        error.errors.map(err => err.detail)
                    )

                    return Observable.of(erroExportacao)
                }

                throw error
            })
        )

        return Observable.forkJoin(retornos$).concatMap(retornos => {
            const erros = retornos
                .filter(obj => obj instanceof ErroExportacao)
                .map(obj => <ErroExportacao>obj)

            return ExportacaoFinalizada.fromExportacoesGeradas(exportacoes, config, erros, formato)
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/exportacao-movimento/shared/exportacao.service.ts